import { useRef, useState } from "react";
import { changeFileName } from "../utils/file";

export function useFileUpload(fileName = "", documentId = null) {
  const inputRef = useRef(null);

  const [fileInfo, setFileInfo] = useState(null);

  const isFileUploaded = fileInfo?.base64;

  const [errorMessage, setErrorMessage] = useState("");

  function handleFileChange(event) {
    const files = event.target.files;

    if (!files) return;

    const lastFile = files[files?.length - 1];

    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result;
      
      const newFileInfo = {
        base64: base64String,
        file: fileName ? changeFileName(lastFile, fileName) : lastFile,
      };

      if (documentId) newFileInfo.documentId = documentId;

      setFileInfo((_) => newFileInfo);
    };

    reader.readAsDataURL(lastFile);
  }

  function onSetFileInfo(fileInfo) {
    setFileInfo(fileInfo);
  }

  function propagateFileChange() {
    return {
      ref: inputRef,
      onChange: handleFileChange,
      fileInfo,
    };
  }

  return {
    inputRef,
    fileInfo,
    handleFileChange,
    propagateFileChange,
    onSetFileInfo,
    errorMessage,
    setErrorMessage,
    isFileUploaded,
  };
}
